<template>
  <div
    class="asc-custom-alerts-grid-wrapper--container"
    data-automation-id="wrapper_custom_alerts_grid"
  >
    <asc-card class="asc-issue-investigation-container__card" no-spacing flat>
      <v-container class="pa-0" fluid>
        <v-row no-gutters>
          <v-col md="14" sm="16">
            <asc-tab v-model="model">
              <asc-tab-title title="My Analytics" />
              <asc-tab-title title="Shared Analytics" />
            </asc-tab>
          </v-col>
        </v-row>
      </v-container>
    </asc-card>
    <asc-tab-body :value="model">
      <asc-tab-item>
        <asc-custom-alerts-grid
          :values="getFilteredColumnDefs"
          :shared-alerts="sharedAlerts"
          :user-airlines="userAirlines"
          :is-shared-tab="isSharedTab"
          :user="user"
          :disable-snap-shot-toggles="getdisableSnapShotToggles"
          :disable-full-flight-toggles="getdisableFullFlightToggles"
          @openAlertTypeDialog="openAlertTypeDialogHandler"
          @toggleAlert="toggleAlertHandler"
          @onDeleteAlert="handleDeleteAlert"
          @editAlert="handleEditAlert"
        ></asc-custom-alerts-grid>
      </asc-tab-item>
      <asc-tab-item>
        <asc-custom-alerts-grid
          :values="getFilteredColumnDefs"
          :user-airlines="userAirlines"
          :is-shared-tab="!isSharedTab"
          :user="user"
          :disable-snap-shot-toggles="getdisableSnapShotToggles"
          :disable-full-flight-toggles="getdisableFullFlightToggles"
          @openAlertTypeDialog="openAlertTypeDialogHandler"
          @toggleAlert="toggleAlertHandler"
          @editAlert="handleEditAlert"
          @onDeleteAlert="handleDeleteAlert"
        ></asc-custom-alerts-grid>
      </asc-tab-item>
    </asc-tab-body>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscCustomAlertsGrid from '@/components/molecules/AscCustomAlertsGrid'
import AscSticky from '@/components/atoms/AscSticky'
import AscCard from '@/components/atoms/AscCard'
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'

import {
  CUSTOM_ALERT_FULL_FLIGHT_DATA_ID,
  CUSTOM_ALERT_SNAPSHOT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID,
  CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT,
} from '@/utilities/appConsts'

export default {
  name: 'AscCustomAlertsGridWrapper',

  components: {
    AscCustomAlertsGrid,
    AscAccentButton,
    AscSticky,
    AscCard,
    AscTab,
    AscTabBody,
    AscTabItem,
    AscTabTitle,
  },

  props: {
    title: {
      type: String,
      default: 'Custom Analytics',
    },
    values: {
      type: Array,
      default: () => [],
    },
    sharedAlerts: {
      type: Array,
      default: () => [],
    },
    hideActionFooter: {
      type: Boolean,
      default: false,
    },
    isAirlineUser: {
      type: Boolean,
      default: false,
    },
    isAcmfUser: {
      type: Boolean,
      default: false,
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
    customAlertsFullFlightSimplePermission: {
      type: Boolean,
      default: false,
    },
    customAlertsFullFlightAdvancedPermission: {
      type: Boolean,
      default: false,
    },
    customAlertsAcmfSimplePermission: {
      type: Boolean,
      default: false,
    },
    customAlertsAcmfAdvancedPermission: {
      type: Boolean,
      default: false,
    },
    customAlertsDplfAdvancedPermission: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      snapShotActiveCount: 0,
      fullFlightActiveCount: 0,
      snapShotCounterLimit: 5,
      fullFlightCounterLimit: CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT,
      tabIndex: 0,
      isSharedTab: false,
    }
  },

  computed: {
    getdisableSnapShotToggles() {
      return this.snapShotActiveCount === this.snapShotCounterLimit
    },
    getdisableFullFlightToggles() {
      return this.fullFlightActiveCount === this.fullFlightCounterLimit
    },
    model: {
      get() {
        return 0
      },
      set(newVal) {
        this.tabIndex = newVal
        if (newVal === 0) {
          this.isSharedTab = false
        } else {
          this.isSharedTab = true
        }
      },
    },
    getFilteredColumnDefs() {
      let columnDefs
      if (this.isSharedTab) {
        columnDefs = this.sharedAlerts.filter(columnDefObj => {
          return columnDefObj.field !== 'shared'
        })
      } else {
        columnDefs = this.values.filter(columnDefObj => {
          return columnDefObj.field !== 'createdBy'
        })
      }
      return columnDefs
    },
  },

  watch: {
    values(newValue) {
      if (newValue.length > 0) {
        this.getFullFlightActiveCount()
        this.getSnapShotActiveCount()
      }
    },
  },

  mounted() {
    this.getFullFlightActiveCount()
    this.getSnapShotActiveCount()
  },

  methods: {
    toggleAlertHandler(whichAlert) {
      if (
        whichAlert.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID ||
        whichAlert.customAlertTypeId ===
          ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID ||
        whichAlert.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID
      ) {
        whichAlert.isEnabled
          ? this.fullFlightActiveCount++
          : this.fullFlightActiveCount--
        if (this.fullFlightActiveCount > this.fullFlightCounterLimit) {
          whichAlert.isEnabled = false
          this.fullFlightActiveCount--
        }
      } else if (
        whichAlert.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID ||
        whichAlert.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID
      ) {
        whichAlert.isEnabled
          ? this.snapShotActiveCount++
          : this.snapShotActiveCount--
      }
      this.$emit('toggleAlert', whichAlert)
    },
    openAlertTypeDialogHandler() {
      this.$emit('openAlertTypeDialog')
    },
    handleEditAlert(whichAlert) {
      this.$emit('handleEditAlert', whichAlert)
    },

    handleDeleteAlert(alert) {
      this.$emit('onDeleteAlert', alert)
    },

    getFullFlightActiveCount() {
      const fullFlightActiveAlerts = this.values.filter(alertObj => {
        return (
          alertObj.isEnabled &&
          (alertObj.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID ||
            alertObj.customAlertTypeId ===
              ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID ||
            alertObj.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID)
        )
      })
      this.fullFlightActiveCount = fullFlightActiveAlerts.length
    },
    getSnapShotActiveCount() {
      const snapShotActiveAlerts = this.values.filter(alertObj => {
        return (
          alertObj.isEnabled &&
          (alertObj.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID ||
            alertObj.customAlertTypeId ===
              ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID)
        )
      })
      this.snapShotActiveCount = snapShotActiveAlerts.length
    },
    filterSharedValues() {
      return this.values.filter(x => x.isShared)
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts-grid-wrapper--container {
  background: $primary-white;
}

.asc-custom-alerts-grid-wrapper--header {
  display: flex;
}

.asc-custom-alerts-grid--actionFooter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 16px;
  width: 100%;

  .asc-accent-button-container {
    margin-right: 12px;
  }
}

.asc-tabs {
  .v-tabs-bar {
    height: auto !important;
    width: 100%;
  }

  .v-tabs-bar__content {
    max-height: 43px;
  }
}

.text-alignment {
  text-align: left;
  padding-bottom: 10px;
  padding-left: 3px;
  position: relative;
}
</style>
